
/*
 * 인트로 서비스 
 * Author : KimTaeOh
 * @$introRootSelector : intro Container Selector 
 * @appLoadingSelector : App Loading Selector
 * @cookieValue : 다시 보지 않기 쿠키 생성시 값 
 * @cookieExpired : 다시 보지 않기 쿠키 만료일 
 * @cookieNameSuffix : 다시 보지 않기 쿠키를 위한 네임의 Suffix 
 * @isCookieRequired : 다시보지 않기 여부를 결정하는 FLAG 
 * @introTrasintionTimer : 전환시간 (ms)
 */

import GentleAppState from '../common/appstate';
import GentleLang from '../common/lang';
import GentleUtil from '../common/util';
import template from '../template/marketingPlan';

// console.log = () => {};
console.log('version> 2025.5.22.20');

console.log('이전페이지', document.referrer)

var GentleServiceIntro = Object.create(null,{
    $introRootSelector:{ writable: false, configurable: false, enumerable: true, value:$("#intro")},
    $appLoadingSelector:{ writable: false, configurable: false, enumerable: true, value:$("#app-loading")},
    appLoadingTrasintionTimer:{ writable: false, configurable: false, enumerable: true, value:800},
    introTrasintionTimer:{ writable: false, configurable: false, enumerable: true, value:4000},
    cookieValue:{ writable: false, configurable: false, enumerable: true, value:"Y"},
    cookieExpired:{ writable: false, configurable: false, enumerable: true, value:365},
    cookieNameSuffix:{ writable: false, configurable: false, enumerable: true, value:"_intro_read"},
    isCookieRequired:{ writable: true, configurable: false, enumerable: true}
});


let lang;

// 인트로 HTML
// TODO : 현수님 Html디자인 패턴으로 리팩토링 및 translate로 텍스트 구간 처리

// 인트로 초기화 
// 인트로에 필요한 HTML을 Append합니다 
// 이후 인트로를 실행합니다 
// @opt.startScene : 처음으로 로딩할 scence ID 
// @opt.ignoreCookie : 쿠키를 무시하고 인트로를 실행합니다 
// @opt.skipAppLoading : 앱로딩을 건너뜁니다 
GentleServiceIntro.introInit = function(opt){
    // console.log('GentleServiceIntro.introInit', opt);
    // console.log('GentleAppState', GentleAppState);
    lang = GentleAppState.lang.toUpperCase();

    GentleServiceIntro.introHtml = {
        common:`
        <div id="scene-common-1" class="scene" data-backgroundurl="/assets/images/intro/common-scene-1-bg.png" data-autoplay="true">
            <p class="large-comment animated">
            ${lang === GentleLang.lang.KR ? 
                '<span class="font-light">안녕하세요,</span><br>애터미 빌리지에<br>오신 걸 환영합니다!' : 
                '<span class="font-light">Hello and welcome to Atomy Village!'}
            </p>
        </div>
        <div id="scene-common-2" class="scene" data-backgroundurl="/assets/images/intro/common-scene-2-bg.png" data-autoplay="true">
            <section class="top">
                <p class="large-comment animated">
                ${lang === GentleLang.lang.KR ? 
                    '<span class="font-light">이곳에선 애터미 일상을</span><br>조금 더 쉽고<br>편하게 누릴 수 있어요.' : 
                    `<span class="font-light">Here, you can enjoy Atomy's daily life more easily and comfortably.`}
                </p>
            </section>
        </div>
        <div id="scene-common-3" class="scene" data-backgroundurl="/assets/images/intro/common-scene-3-bg.png" data-autoplay="true">
            <section class="top">
                <p class="large-comment animated">
                ${lang === GentleLang.lang.KR ? 
                    '<span class="font-light">앞으로 고객님의</span><br>일상에 함께할 챗봇을<br>소개해드립니다.' : 
                    '<span class="font-light">I will introduce the chatbots that will be with you in your daily life.'}
                </p>
            </section>
        </div>
        `,
    
        papa:`
        <div id="scene-papa-1" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-1.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '반갑습니다, 애터미에 온 걸 환영해요^^<br>저와 함께 애터미에 대해 알아볼까요?' : "It's nice to meet you; welcome to Atomy. Shall we learn about Atomy?"}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '좋아요' : 'Good!'}
                            </button>        
                            <button class="secondary default close-intro">
                            ${lang === GentleLang.lang.KR ? '대화를 마칠래요' : 'I want to end this conversation.'}
                            </button>        
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-2" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-2-3-18.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? 
                        '아, 소개가 늦었네요.<br><strong>저는 PAPA 파파 박사</strong>입니다.<br>편하게 <strong>파파</strong>라고 부르세요!' : 
                        "Ah, the introduction is late. I'm Dr. PAPA. Feel free to call me PAPA!"}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '파파는 어떤 일을 하나요?' : 'What does PAPA do?'}
                            </button>  
                        </div>
                    </div>
                </div>
            </section>
        </div>    
        <div id="scene-papa-3" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-2-3-18.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? 
                        '우리 애터미 소비자 회원분들에게는<br>쇼핑 가이드를, 초기 사업자분들에게는<br>멘토 역할을 하고 있어요^^' : 
                        'I serve as a shopping guide for our Atomy consumer members and also as a mentor for early business owners.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '더 자세히 알고 싶어요.' : 'I want to know more.'}
                            </button>  
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-4" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-4-6-7-8-9.png">
            <section class="top">
                <div class="card">
                    <p style="line-height:1.6">
                    ${ lang === GentleLang.lang.KR ? 
                        '더 자세히 알고 싶다면 이 메뉴를 보면<br>알 수 있어요. 언제든 제 도움이 필요하면<br>왼쪽 아래 <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon"> 버튼을 누르세요.' : 
                        'If you want to know more, you can find out by looking at this menu. If you need my help at any time, please click the <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon"> button in the lower left corner.'}<br>
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '아하, 알겠어요.' : 'Ah, I see.'}
                            </button>  
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-5" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-5.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '혹시 이제 막 사업을 시작한 회원인가요?<br>그럼 마케팅 플랜 이야기를 꼭 해야겠네요.' : 'Are you a member just starting a business? Then we need to talk about the marketing plan.'}<br>
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '마케팅 플랜이 무엇인가요?' : 'What is your marketing plan?'}
                            </button>  
                            <button class="secondary default close-intro">
                            ${lang === GentleLang.lang.KR ? '다음에 이야기해요.' : "Let's talk later."}
                            </button>  
                        </div>
                    </div>
                </div>
            </section>
        </div>    
        <div id="scene-papa-6" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-4-6-7-8-9.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? 
                        '애터미인 모두의 성공을 바라는<br>우리만의 보상정책이 바로<br>마케팅 플랜이에요. 사업자 회원이라면<br>꼭 알아야 하죠.' : 
                        "Our marketing plan is our own compensation policy that aims for the success of all Atomy people. If you're a business member, then you must know."} 
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '오.. 어떤 보상이 있나요?' : 'Oh.. what rewards?'}
                            </button>  
                            <button class="secondary default close-intro">
                            ${lang === GentleLang.lang.KR ? '그렇군요, 이제 그만 들을게요.' : "Okay, I'll stop listening now."}
                            </button>  
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-7" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-4-6-7-8-9.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '쉽게 말해 각자가 달성한 목표에 따라<br>수당을 지급받을 수 있습니다.' : "In simple terms, each of them can be paid according to the goals they've achieved."}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '어떤 수당이죠?' : 'What kind of allowance?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-8" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-4-6-7-8-9.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '수당은 총 4가지가 있어요.<br>회원등급, 후원수당, 직급수당, 교육수당인데.. 어렵진 않아요^^<br>가볍게 들어보겠어요?' : "There are a total of 4 allowances. Membership level, general commission, mastership bonus, education commission... It isn't difficult. Would you like to hear about it briefly?"}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '회원등급 알려주세요.' : 'Please tell me your membership level.'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-9" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-4-6-7-8-9.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '회원등급은 본인의 매출 실적 또는<br>전월 하위 그룹 소실적에 따라<br>정해지는 등급입니다.' : 'The membership level is determined according to your sales performance or smaller subgroup leg in the previous month.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? 'PV는 뭔가요?' : 'What is PV?'}
                            </button> 
                        </div>
                    </div>
                </div>   
            </section>
            
                <div class="gentle-button-group margin-zero absolute-bottom">
                        <div class="wide-button">
                            <button class="primary default big" name="pop-level">
                                <strong>
                                ${lang === GentleLang.lang.KR ? '회원등급 및 취득조건' : 'Membership Level and Acquisition Conditions'}
                                </strong>
                                <img src="/assets/images/atomy/icons-down.png" srcset="/assets/images/atomy/icons-down@2x.png 2x" class="down-icon">
                            </button> 
                        </div>
                    </div>
            
            
        </div>  
        <div id="scene-papa-10" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-10.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? 'Point Value의 약자로서 애터미 상품을<br>구매하면 받을 수 있는 포인트예요.<br>일반적인 포인트와는 달리 구매할 때<br>사용 할 순 없지만, 수당 산정의 기준이 됩니다.' : 'As an abbreviation for Point Value, it is a point that can be received by purchasing Atomy products. Unlike general points, they cannot be used for purchases, but they become the basis for calculating allowances.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '그럼 소실적 PV는 뭔가요?' : 'So what is smaller leg PV?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-11" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-11.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '본인의 <strong>좌우회원 중 PV가 적은 쪽이</strong><br><strong>소실적</strong>이에요. 아래 예시는<br>우측이 소실적이겠네요.<br><br> 지난달 좌우회원의 PV가<br>본인의 수당에도 영향을 미치는 거죠.' : 'Among the members on the downliners, the one with the least PV is more costly. In the example below, the one on the right is probably smaller leg. The PV of the downliners last month also affects their pay.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '아하! 알겠어요.' : 'Aha! I get it now.'}
                            </button>  
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-12" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-12.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '좋습니다^^<br>두 번째, 후원수당이에요.<br>회사 총 매출 PV 44%에서 본인이 취득한<br>점수만큼 받을 수 있는 수당이죠.' : "Okay. Second, it's a general commission. This is an allowance you can receive equivalent to the points you have earned from the company's total sales PV 44%."}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '네, 다음 직급수당은요?' : 'Yes, how about the Mastership bonus?'}
                            </button> 
                            <button class="secondary default" name="pop-score" >
                            ${lang === GentleLang.lang.KR ? '후원수당 점수를 자세히 알려주세요.' : "Please tell me more details about the general commission points."}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-13" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-13-14-15-16-17.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '직급수당도 역시 회사 총 매출 PV 20%에서<br>본인의 직급에 따라 지급되는 수당이에요.<br>등급은 총 7개고, 각 등급을 유지하기<br>위한 조건이 있어요.' : "Mastership bonus is also paid according to one's position from 20% of the company's total sales PV. There are a total of 7 grades, and there are conditions for maintaining each grade."}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '유지 조건이요?' : 'maintenance conditions?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
    
            <figure>
            <img src = "/assets/images/banner/${lang === GentleLang.lang.KR ? 'b6.png': 'b6_en.png'}" srcset="/assets/images/banner/${lang === GentleLang.lang.KR ? 'b6@2x.png 2x': 'b6_en@2x.png 2x'}">
            </figure>
        </div>
        <div id="scene-papa-14" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-13-14-15-16-17.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '크게 두 가지가 있는데요, 먼저 본인의<br>직급에 맞는 회원등급을 유지해야 합니다.<br>그리고 하위 좌우 라인 각각 2명 이상이<br>또 특정 직급을 취득해야 하죠.' : 'There are two main types. First, you must maintain a membership level that is appropriate for your position. And at least two people in each of the lower left and right lines must also acquire a specific mastership.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '직급 승급은 어떻게 해요?' : 'How do I get promoted?'}
                            </button> 
                            <button class="secondary default " name="pop-condition">
                            ${lang === GentleLang.lang.KR ? '직급별 유지조건을 볼래요.' : "Let's see the maintenance conditions by mastership."}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-15" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-13-14-15-16-17.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '샤론로즈마스터까지는 <strong>유지 요건이</strong><br><strong>맞다면 언제든 승급</strong>할 수 있어요. 그다음<br>스타마스터부터는 <strong>전 직급을</strong><br><strong>3회이상 유지</strong>해야 승급한답니다.' : "You can upgrade to Sharon Rose Master at any time as long as the maintenance requirements are met. From the next Star Master, you must maintain all ranks at least 3 times to be promoted."}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '승급하면 혜택이 있나요?' : 'Are there any benefits when upgrading?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-16" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-13-14-15-16-17.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '그럼요^^ 우리 회원님의 승급을 축하하는<br>프로모션을 드립니다. 애터미 제품 제공부터<br>현금, 자동차, 가족 해외 여행권까지 다양해요.' : "That's right. We're running promotional giveaways to celebrate our members' promotions. They range from offering Atomy products to cash, automobiles, and overseas travel vouchers for families."}<br>
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '좋네요. 교육수당도 알려주세요.' : "That sounds great. Please teach me more about the education commission."}
                            </button> 
                            <button class="secondary default " name="pop-promotion">
                            ${lang === GentleLang.lang.KR ? '프로모션을 자세히 알고싶어요.' : 'I want to learn more about the promotion.'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-17" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-13-14-15-16-17.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '교육수당은 각 센터 소속회원의<br>총 매출 PV에서  6%를 지급하는 수당이에요.' : 'The education commission is an allowance paid at 6% of the total sales PV of members affiliated with each center.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '4가지 수당 이해했어요.' : 'I understand the 4 types of commissions.'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-18" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-2-3-18.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '아직은 조금 헷갈릴 수 있어요..^^<br>궁금한 게 있다면 언제든 저를 찾아도 돼요.<br>전 질문을 아주 좋아합니다.' : "It can still be a bit confusing..^^ If you have any questions, you can always find me. I love questions."}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '어떻게 물어봐야 하죠?' : 'How can I ask you a question?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-19" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-19.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '아주 쉽답니다! 아래처럼 물어볼 수도 있죠.' : "It's very easy! You can also ask questions like those below."}
                    </p>    
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '애터미에서 인기있는 상품은?' : 'What are the popular products at Atomy?'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '하위매출 보여주세요' : 'Show the Group Purchase'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '마케팅 플랜 알려줘요' : 'Tell me about your marketing plan.'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
    
                    <p style="padding-bottom:0">
                    ${lang === GentleLang.lang.KR ? '아, 자주 하는 질문을 먼저 보면 궁금한 점을<br>미리 해소할 수 있겠네요.' : "Oh, if you check out the frequently asked questions first, then you may be able to resolve your questions in advance."}
                    </p>
    
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '자주 하는 질문이요?' : 'Frequently asked questions?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-papa-20" class="scene" data-backgroundurl="/assets/images/intro/papa-scene-20.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '네,<br>특히 쇼핑 관련한 단골 질문들이 있죠.<br>저와 대화를 마치고<br>아래처럼 입력해보면 알 수 있어요.' : "Yes, I have questions, especially when it comes to shopping. After talking with me, you can find out more information by entering the following."}
                    </p>
    
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '회원들이 자주하는 질문은?' : 'What questions do the members frequently ask?'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
    
                    <p>
                    ${lang === GentleLang.lang.KR ? '자 그럼! 이만 설명은 마치고<br>애터미 일상을 시작해보죠^^' : "Well then! After this explanation, let's check out a day in the life of Atomy!^^"}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default close-intro">
                            ${lang === GentleLang.lang.KR ? 'PAPA 파파와 대화 마치기' : 'End the conversation with PAPA.'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        `,
    
        tomy:`
        <div id="scene-tomy-1" class="scene" data-backgroundurl="/assets/images/intro/tomy-scene-1-bg.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '만나 뵙게 되어 반갑습니다!<br>앞으로 회원님의 업무를 도와드리게 될<br><strong>비서 TOMY 토미</strong>입니다.<br>' : "Nice to meet you! I'm TOMY, and I'm a secretary who will help you with your business in the future."}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '반가워요 토미!' : 'Nice to meet you, TOMY!'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-tomy-2" class="scene" data-backgroundurl="/assets/images/intro/tomy-scene-2-bg.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '저는 회원님께서<br>애터미 업무를 수월하게 진행하실 수 있게끔<br>여러 업무를 수행하고 있어요.<br>쇼핑하실 때도 물론 동행합니다.<br>' : 'I carry out various tasks so that members can handle their Atomy business with ease. Of course, I accompany you while shopping.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '어떤 걸 수행하나요?' : 'What do you do?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-tomy-3" class="scene" data-backgroundurl="/assets/images/intro/tomy-scene-3-bg.png">
            <section class="top">
                <div class="card">
                    <p style="line-height:1.6">
                    ${lang === GentleLang.lang.KR ? '가장 필요하실 것 같은 업무를 메뉴로<br>준비해보았는데요, 언제든 아래 <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon"> 를<br>눌러 원하는 업무를 선택해주시면<br>제가 바로 수행합니다.<br>' : 'I have prepared a menu for the tasks you think you will most likely need. If you click the <img src="/assets/images/atomy/menu-icon.png" srcset="/assets/images/atomy/menu-icon@2x.png 2x" class="menu-icon"> below at any time to select the task you want, I will perform it immediately.'}
                    </p>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '다른 업무는 어떻게 맡기면 되죠?' : 'How can I assign other tasks?'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-tomy-4" class="scene" data-backgroundurl="/assets/images/intro/tomy-scene-4-bg.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '언제든 대화창에<br>아래처럼 물어봐 주시면 됩니다.<br>' : 'You can always ask questions in the chat window below.'}
                    </p>
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '소실적 맞추고 싶은데 어떻게 해요?' : 'I want to make it small leg, how can I do that?'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '회원초대하고 싶어요.' : 'I want to invite members.'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '이번에 받은 수당 보고 싶어요.' : 'I want to see the commission I have received to this point.'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default next-scene">
                            ${lang === GentleLang.lang.KR ? '그렇군요, 알겠어요.' : 'All right, I understand.'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div id="scene-tomy-5" class="scene" data-backgroundurl="/assets/images/intro/tomy-scene-5-bg.png">
            <section class="top">
                <div class="card">
                    <p>
                    ${lang === GentleLang.lang.KR ? '아참!<br>혹시 마케팅 플랜에 대해<br>다시 한번 설명이 필요하시면<br>저와 대화를 마친 후,<br>입력창에 아래처럼 말씀해주세요.<br>' : 'Oh! If you need any further explanation about your marketing plan, please tell me in the chat box after talking with me.'}
                    </p>
                    <div class="flex-box space-between flex-align-center talk-examle">
                        <span>
                        ${lang === GentleLang.lang.KR ? '마케팅 플랜에 대해 알려주세요.' : 'Tell me about your marketing plan.'}
                        </span>
                        <img src="/assets/images/atomy/img/send.png" srcset="/assets/images/atomy/send@2x.png 2x" class="send">
                    </div>
                    <div class="gentle-button-group">
                        <div class="wide-button">
                            <button class="primary default close-intro">
                            ${lang === GentleLang.lang.KR ? 'TOMY 토미와 대화 마치기' : 'End the conversation with TOMY.'}
                            </button> 
                        </div>
                    </div>
                </div>
            </section>
        </div>
        `
    }

    console.log('lang>', lang);

    this.$appLoadingSelector.css('opacity',1);
    this.$introRootSelector.css('opacity', 1);
    this.$introRootSelector.css('z-index', '');

    // 쿠키이름 
    this.cookieName = GentleAppState.persona + this.cookieNameSuffix;

    // 토미 혹은 파파 인트로 디스플레이 여부를 결정하기 위한 변수 
    console.log('opt>', opt);
    const {intro} = (opt.intro === undefined)?{}:opt;
    console.log('intro>', intro);
    const startScene = (intro.startScene === undefined)?undefined:intro.startScene;
    const ignoreCookie = (intro.ignoreCookie === true)?true:false;
    const skipAppLoading = (intro.skipAppLoading === true)?true:false;

    const tomyIntroDisplay = (GentleUtil.getCookie(this.cookieName) != "Y" && GentleAppState.persona == 'tomy')?true:false;
    const papaIntroDisplay = (GentleUtil.getCookie(this.cookieName) != "Y" && GentleAppState.persona == 'papa')?true:false;
    const appLoadingTimer = (skipAppLoading===true)?0:this.appLoadingTrasintionTimer;
    
    // 앱로딩 스킵 
    //if(skipAppLoading === true){
    //    this.$appLoadingSelector.remove();
    //}

    // 인트로 구현 조건 ( 쿠키여부 무시 || 토미 인트로 해당 || 파파 인트로 해당 )

    if( ignoreCookie === true || tomyIntroDisplay === true || papaIntroDisplay === true ){
        // 공통요소 마크업을 추가합니다
        $( this.introHtml['common'] ).appendTo( this.$introRootSelector );

        // 퍼소나에 맞는 마크업을 추가합니다 
        const $personaIntroHtml = $(this.introHtml[GentleAppState.persona]);

        // 마크업 추가 
        $( $personaIntroHtml ).appendTo( this.$introRootSelector );
        
         // 전체 Scene을 담는다 
        this.$scensAll = this.$introRootSelector.find('.scene');

        // 시작 Scene이 있으면 실행하고 없으면 app-loading을 제외한 1번 요소 가져오기 
        this.$scene = (startScene !== undefined)?$('#'+intro.startScene):this.$scensAll.not("#" + this.$appLoadingSelector.attr('id') ).eq(0);
        

        // 다음씬으로 이동 이벤트 바인딩 
        this.$scensAll.find(".next-scene").on('click', {target:this}, function(event){
            const nextSceneId = $(this).closest(".scene").next().attr('id');
            event.data.target.$scene = $('#'+nextSceneId);
            event.data.target.showIntro();
        });
        
        // 닫기 이벤트 바인딩 
        this.$scensAll.find(".close-intro").on('click', {target:this}, function(event){
            event.data.target.isCookieRequired = true;
            event.data.target.hideIntro();
        });

        this.$scensAll.find('[name="pop-level"]').on('click', {target:this}, function(event){
            console.log('회원등급 및 취득조건');

            const title = lang === GentleLang.lang.KR ? '회원등급 및 취득조건' : 'Membership Level and Acquisition Conditions';
            const content = template.level({lang, isPopup:true});
            GentleUtil.createSlidePopup({title, content, autoHeight:'full'});
        });

        this.$scensAll.find('[name="pop-score"]').on('click', {target:this}, function(event){
            console.log('후원수당 점수');

            const title = lang === GentleLang.lang.KR ? '후원수당 점수 기준' : 'Based on general commission Points';
            const content = template.score({lang});
            GentleUtil.createSlidePopup({title, content, autoHeight:'full'});
        });

        this.$scensAll.find('[name="pop-condition"]').on('click', {target:this}, function(event){
            console.log('직급별 유지조건');

            const title = lang === GentleLang.lang.KR ? '직급별 유지조건' : 'Retention conditions by mastership';
            const content = template.condition({lang});
            GentleUtil.createSlidePopup({title, content, autoHeight:'full'});
        });

        this.$scensAll.find('[name="pop-promotion"]').on('click', {target:this}, function(event){
            console.log('승급 축하 프로모션');

            const title = lang === GentleLang.lang.KR ? '승급 축하 프로모션' : 'Promotion gift package';
            const content = template.promotion({lang});
            GentleUtil.createSlidePopup({title, content, autoHeight:'full'});            
        });


        // 로딩바 타이머 이후 실행 
        setTimeout(function(){
            GentleServiceIntro.showIntro();
        }, appLoadingTimer );

    }else{
        
        // 실행할 인트로가 없다면 로딩바를 타이머 이후 제거 
        setTimeout(function(){
            GentleServiceIntro.hideIntro();
        }, appLoadingTimer );
        
    }
}

// 인트로를 위한 퀵메뉴 동작 이벤트 
GentleServiceIntro.tempQuickMenuClickEvent = function(){
    if(GentleAppState.$composerAreaContainerSelector.hasClass('quick-menu-show')){
        GentleAppState.$composerAreaContainerSelector.removeClass('quick-menu-show');
    }else{
        GentleAppState.$composerAreaContainerSelector.addClass('quick-menu-show');
    }
}

// 인트로 실행
GentleServiceIntro.showIntro = function(){
    if(!this.$scene || this.$scene.length === 0){
        this.hideIntro();
        throw new Error('요청하신 인트로가 존재하지 않습니다');
    }

    // 현재 Scene을 활성화 합니다 
    this.$scensAll.css('opacity', 0);
    this.$scensAll.attr('z-index', 9999);

    this.$scene.css('opacity', 1);
    this.$scene.css('z-index', 10000);
    

    switch( this.$scene.attr('id') ){
        case "scene-papa-4" :
        case "scene-tomy-3" :
            this.$introRootSelector.addClass('position-back');
            GentleAppState.$composerAreaContainerSelector.addClass('intro-ing');
            GentleAppState.$quickMenuButtonSelector.on('click', GentleServiceIntro.tempQuickMenuClickEvent);
            break;
        default : 
            this.$introRootSelector.removeClass('position-back');
            GentleAppState.$composerAreaContainerSelector.removeClass('intro-ing');
            GentleAppState.$composerAreaContainerSelector.removeClass('quick-menu-show');
            GentleAppState.$quickMenuButtonSelector.off('click', GentleServiceIntro.tempQuickMenuClickEvent);
            GentleUtil.quickMenuHide();
            break;
    }

    // auto play & lazy load 
    this.lazyLoadCallback = undefined;
    if( this.$scene.data('autoplay') === true){
        this.lazyLoadCallback = function(){
            const nextSceneId = this.$scene.next().attr('id');
            const timer = (this.$scene.data('autotimer'))?this.$scene.data('autotimer'):this.introTrasintionTimer;
            let callBack;
            if(nextSceneId !== undefined){    
                this.$scene = $('#'+nextSceneId);
                callBack = function(){
                    GentleServiceIntro.showIntro();
                }
            }
            setTimeout(callBack, timer );
        }
    }

    if( this.$scene.data('backgroundurl') ){
        this.lazyLoadSceneImage();
    }    
}

// 인트로 감추기 
GentleServiceIntro.hideIntro = function(){

    // 자연스러운 제거를 위해 Opacity Animation 
    this.$introRootSelector.css('opacity', 0);
    this.$introRootSelector.css('z-index', 0);

    // 자연스러운 제거를 위해 Animation 이후 Remove 
    if(this.$scensAll !== undefined){
        setTimeout(function(){
            GentleServiceIntro.$introRootSelector.find(".scene").not('#' + GentleServiceIntro.$appLoadingSelector.attr('id')).remove();
        }, 1000);
    }

    // 다시보지 않기 
    if(this.isCookieRequired === true){
        GentleUtil.setCookie( this.cookieName, this.cookieValue, this.cookieExpired);
    }


    // on-intro Class 제거 ( 사이즈 강제 조정 )
    GentleAppState.$appRoot.removeClass('on-intro');
}


// 퍼포먼스를 위해 전환시점에 현재 Scene 이미지를 로딩후 전환 
GentleServiceIntro.lazyLoadSceneImage = function(cb){
    const imageUrl = this.$scene.data('backgroundurl'); 
    let preloaderImg = document.createElement("img");
    preloaderImg.src = imageUrl;
    

    // 이미지 요소를 로딩한후 BG를 할당하고 애니메이션 요소를 ON한다 
    if(imageUrl !== undefined){
        preloaderImg.addEventListener('load', (event) => {

            this.$scene.css('background-url', imageUrl);
            this.$scene.css({"background":"url("+imageUrl+")"}); 		
            this.$scene.css("background-size", "cover");
            this.$scene.css("background-position", "center");
            this.$scene.css('opacity', 1);
            this.$scene.find(".animated").addClass('on');
            preloaderImg = null;

            // 전환이후 콜백
            if(this.lazyLoadCallback !== undefined){
                this.lazyLoadCallback();
            }
        });
    }
}


export default GentleServiceIntro;